import { currentOrPastMonthYearDateUI } from 'platform/forms-system/src/js/web-component-patterns';
import VaCheckboxField from 'platform/forms-system/src/js/web-component-fields/VaCheckboxField';
import {
  dateRangeAdditionalInfo,
  detailsPageBegin,
  endDateApproximate,
  getOtherFieldDescription,
  herbicidePageTitle,
  notSureDatesDetails,
  reviewDateField,
  startDateApproximate,
} from '../../content/toxicExposure';
import { validateToxicExposureDates } from '../../utils/validations';
import { validateApproximateMonthYearDate } from '../../../shared/utils/dates';
import {
  ForceFieldBlur,
  makeDateConfirmationField,
  monthYearDateSchemaWithFullDateSupport,
} from './utils';

export const uiSchema = {
  'ui:title': ({ formData }) => {
    return detailsPageBegin(
      herbicidePageTitle,
      getOtherFieldDescription(formData, 'otherHerbicideLocations'),
    );
  },
  toxicExposure: {
    otherHerbicideLocations: {
      startDate: {
        ...currentOrPastMonthYearDateUI({
          title: startDateApproximate,
          monthOptional: true,
        }),
        'ui:required': false,
        // Replace platform validation (validateCurrentOrPastMonthYear) with custom validation
        'ui:validations': [validateApproximateMonthYearDate],
        'ui:errorMessages': {
          pattern: 'Please enter a valid date',
          required: 'Please enter a date',
        },
        'ui:reviewField': reviewDateField,
        'ui:confirmationField': makeDateConfirmationField(startDateApproximate),
      },
      endDate: {
        ...currentOrPastMonthYearDateUI({
          title: endDateApproximate,
          monthOptional: true,
        }),
        'ui:required': false,
        // Replace platform validation (validateCurrentOrPastMonthYear) with custom validation
        'ui:validations': [validateApproximateMonthYearDate],
        'ui:errorMessages': {
          pattern: 'Please enter a valid date',
          required: 'Please enter a date',
        },
        'ui:reviewField': reviewDateField,
        'ui:confirmationField': makeDateConfirmationField(endDateApproximate),
      },
      'ui:validations': [validateToxicExposureDates],
      'view:notSure': {
        'ui:title': notSureDatesDetails,
        'ui:webComponentField': VaCheckboxField,
        'ui:options': {
          classNames: 'vads-u-margin-y--3',
        },
      },
    },
    'view:herbicideAdditionalInfo': {
      'ui:description': dateRangeAdditionalInfo,
    },
  },
  _forceFieldBlur: {
    'ui:field': ForceFieldBlur,
    'ui:options': {
      hideOnReview: true,
    },
  },
};

export const schema = {
  type: 'object',
  properties: {
    toxicExposure: {
      type: 'object',
      properties: {
        otherHerbicideLocations: {
          type: 'object',
          properties: {
            startDate: monthYearDateSchemaWithFullDateSupport,
            endDate: monthYearDateSchemaWithFullDateSupport,
            'view:notSure': {
              type: 'boolean',
            },
          },
        },
        'view:herbicideAdditionalInfo': {
          type: 'object',
          properties: {},
        },
      },
    },
    _forceFieldBlur: {
      type: 'boolean',
    },
  },
};
